import {ListQuestion} from '../models/list-question';
import { Injectable } from '@angular/core';
import { AssessmentHydrator } from "./assessment-hydrator.service";
import { AssessmentResult } from "../models/assessment-result";
import { ScaleResult } from "../models/scale-result";
import { QuestionSet } from "../models/question-set";
import { Question } from "../models/question";
import { Assessment } from 'app/shared/models/assessment';
import { QuestionSetType } from 'app/shared/models/question-set-type';
@Injectable()
export class AssessmentResultHydrator {
	
	private _assessmentHydrator:AssessmentHydrator;
	
	constructor(assessmentHydrator:AssessmentHydrator) {
		this._assessmentHydrator = assessmentHydrator;
	}
	
	public hydrate(data: any) : AssessmentResult {
		let assessmentResult = new AssessmentResult();
		let answerMap = {};
		assessmentResult.id = data.id || data._id || "";
		
		let assessment = data._assessment || data.assessment;
		let answers = data._answers || [];
		let scaleResults = data._scaleResults || data.scaleResults || [];
		let flaggedQuestions = data._flaggedQuestions || data.flaggedQuestions || [];
		if (assessment) {
			assessmentResult.assessment = this._assessmentHydrator.hydrate(assessment);
			let questionMap = this.createQuestionMap(assessmentResult.assessment);
			let answerMap = this.createAnswerMap(answers);
			this.fillInAnswers(assessmentResult, answerMap);
			assessmentResult.flaggedQuestions = this.getFlaggedQuestions(flaggedQuestions, questionMap);
			
			assessmentResult.scaleResults = scaleResults.map(sr => this.hydrateScaleResult(assessmentResult.assessment, sr));
		}
		
		return assessmentResult;
	}

	private getFlaggedQuestions(flaggedQuestions:string[], questionMap:Map<string, Question>) {
		return flaggedQuestions.map(id => {
			let fq = questionMap.get(id);
			fq.isFlaggedForReview = true; // make sure we mark the question as flagged.
			if (!fq) {
				console.error("Flagged Question not found with id ", id);
			}
			return fq;
		})
		.filter(fq => fq != null);
	}

	private createQuestionMap(assessment:Assessment) : Map<string, Question> {
		let map = new Map<string, Question>();
		assessment.question_sets
			.map(qs => qs.questions)
			.reduce((prev, curr) => curr.concat(prev), [])
			.forEach(q => map.set(q.id, q));
		return map;
	}

	private fillInAnswers(assessmentResult:AssessmentResult, answerMap:any) {
		// populate the answers for the questions from the result set.
		assessmentResult.assessment
			.question_sets.forEach(qs => qs.questions.forEach(q => this.fillInQuestion(q, qs, answerMap)));
	}
	private fillInQuestion(q:Question, questionSet:QuestionSet, answerMap:any) {
		if (!answerMap[q.id]) {
			return;
		}
		// if the question has it's own custom labels we use those instead.
		let score = answerMap[q.id].hasOwnProperty('score') ? answerMap[q.id].score : null;
		q.setComputedScore(score);
		if (questionSet.display_type == QuestionSetType.QUESTION_LIST
			&& q instanceof ListQuestion) {
			q.setSavedAnswer(answerMap[q.id].answer, q.CustomLabels);
		}
		else {
			q.setSavedAnswer(answerMap[q.id].answer, questionSet.labels);
		}
	}

	private createAnswerMap(answers:any[]) {
		let answerMap = {};
		answers.forEach(a => answerMap[a._question_id] = {answer: a._answer, score: a._score});
		return answerMap;
	}
	
	private hydrateScaleResult(assessment:any, srData: any) : ScaleResult {
		let scaleResult = new ScaleResult();
		let score = srData.score || srData._score;
		if (score) {
			scaleResult.score = +score;
		}
		
		let scaleData = srData._scale || srData.scale;
		if (scaleData) {
			scaleResult.scale = this._assessmentHydrator.hydrateScale(scaleData);
		} else if (srData._scaleId) {
			let scale = assessment.scales.find(s => s.id == srData._scaleId);
			if (!scale && assessment.scales.length) {
				scale = assessment.scales[0];
			}
			scaleResult.scale = scale;
		}
		
		let rangeData = srData._range || srData.range;
		if (rangeData) {
			scaleResult.range = this._assessmentHydrator.hydrateScaleRange(rangeData);
		}
		else if (srData._rangeId && scaleResult.scale) {
			let range = scaleResult.scale.ranges.find(r => r.id == srData._rangeId);
			// if for some reason we can't find it... choose the first one.
			if (!range && scaleResult.scale.ranges.length) {
				range = scaleResult.scale.ranges[0];
			}
			scaleResult.range = range;
		}
		else if (scaleResult.scale && scaleResult.scale.ranges
			&& scaleResult.scale.ranges.length) {
				scaleResult.range = scaleResult.scale.ranges[0];
		}
		
		return scaleResult;
	}
}


// WEBPACK FOOTER //
// ./src/app/shared/services/assessment-result-hydrator.service.ts